export const referralsConstants = {
  REFERRALS_GRID_STATE_CHANGE_ACTION:
    '@config/REFERRALS_GRID_STATE_CHANGE_ACTION',
  REFERRALS_GRID_RESET: '@config/REFERRALS_GRID_RESET',
  GET_CAMPAIGNS: '@referrals/GET_CAMPAIGNS',
  POST_CAMPAIGN: '@referrals/POST_CAMPAIGN',
};
